import React from 'react';
import PropTypes from 'prop-types';
import { notice, alert } from 'ducks/notifications';
import { reduxForm } from 'redux-form';
import validators from 'utils/validators';
import generateFormValidation from 'utils/generateFormValidation';
import convertToFormErrors from 'utils/convertToFormErrors';
import api from 'api';
import { withRouter } from 'react-router-dom';
import Field from 'form/Field';
import Form from 'form/Form';
import SubmitButton from 'form/SubmitButton';
import Component from 'BaseComponent';
import config from 'config';
import Pusher from 'pusher-js';
import ProgressBar from 'components/ProgressBar';
import addSeconds from 'date-fns/addSeconds';
import loginToWordpress from 'utils/loginToWordpress';
import autobind from 'autobind-decorator';

@withRouter

@reduxForm({
  form: 'Login',
  validate: generateFormValidation({
    username: [validators.required()],
    password: [validators.required()],
  }),
})

export default class WpLogin extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
  }

  state = {
    isLoading: false,
    startedAt: null,
    averageStartTimeInSeconds: null,
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  @autobind
  handleSubmit(values) {
    const { dispatch } = this.props;
    const props = this.props;

    return dispatch(api.createWpSession(
      { id: props.match.params.slug },
      {
        data: {
          type: 'wpSession',
          attributes: values,
        },
      },
    ))
    .then(({ body: { data, included } }) => {
      dispatch(notice('Login.success'));
      const site = included[0];

      if (site.attributes.wpState === 'running') {
        loginToWordpress(site.attributes.secureAdminUrl, values.username, values.password);
      } else {
        const pusher = new Pusher(
          config.pusher.apiKey,
          {
            cluster: config.pusher.cluster,
            authEndpoint: `${config.apiBaseUrl}/pusher_auth`,
            auth: {
              headers: {
                Authorization: `Bearear ${data.id}`,
              },
            },
          },
        );

        const siteChannel = pusher.subscribe(`private-site-${site.id}`);

        siteChannel.bind('siteStatusChange', ({ wpState }) => {
          if (wpState === 'running') {
            this.sleep(2000).then(() => {
              loginToWordpress(site.attributes.secureAdminUrl, values.username, values.password);
            });
          }
        });

        this.setState({
          isLoading: true,
          startedAt: site.attributes.startedAt,
          averageStartTimeInSeconds: site.attributes.averageStartTimeInSeconds,
        });
      }
      return new Promise(() => true);
    })
    .catch((response) => {
      if (response.body.errors[0].code === 'WP_LOGIN_RATE_LIMIT_REACHED') {
        dispatch(alert('Login.wpLoginRateLimitReached'));
      } else {
        dispatch(alert('Login.invalidCredentials'));
      }
      return Promise.reject(convertToFormErrors(response));
    });
  }

  render() {
    const { handleSubmit, submitting, error, dirty } = this.props;

    return (
      <div className="wp-island">
        <div className="wp-island__wrap">
          <div className="wp-island__logo">
            <img src="/assets/images/wordpress-logo.svg" alt="" height="84" />
          </div>
          <div className="wp-island__content">
            <Form error={error} onSubmit={handleSubmit(this.handleSubmit)} >
              <Field label="WpLogin.username" name="username" placeholder="">
                <input type="text" className="wp-island__input" autoComplete="off" />
              </Field>
              <Field label="WpLogin.password" name="password" placeholder="">
                <input type="password" className="wp-island__input" autoComplete="off" />
              </Field>
              <div className="wp-island__footer">
                <SubmitButton
                  dirty={dirty}
                  className="wp-button"
                  submitting={submitting}
                  label="Login.submit"
                />
              </div>
            </Form>
          </div>
          <div className="space--top-2">
            {
              this.state.isLoading ?
                <ProgressBar
                  startedAt={this.state.startedAt}
                  expectedFinishDate={
                    addSeconds(
                      this.state.startedAt,
                      this.state.averageStartTimeInSeconds,
                    ).toISOString()
                  }
                />
              :
                <div className="Sites__item__fakeprogressbar" />
            }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/WpLogin.jsx